import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import axios from "axios";
import { Outlet, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";

import { ApiDigitalAuthAuthentication } from "../../services/auth/authentication.service";
import { SettingsDA } from "../../services/admin/settings.service";
import { TreasuryAccountDA } from "../../services/admin/treasury.account.service";
import { AccountingAccountDA } from "../../services/admin/accounting.account.service";
import { AccountingEntryDA } from "../../services/admin/accounting.entry.service";
import { ApiDigitalAdminContact } from "../../services/admin/contact.service";
import { normalizeContacts } from "../../scripts/format.value.script";
import { ApiDigitalAdminNotification } from "../../services/admin/notification.service";
import { ProductDA } from "../../services/admin/product.service";
import { ServiceDA } from "../../services/admin/service.service";
import { StorageCenterDA } from "../../services/admin/storage.center.service";
import { ApiDigitalAuthCompany } from "../../services/auth/company.service";
import { ApiDigitalAuthUser } from "../../services/auth/user.service";
import { Error } from "../../models/error.model";
import { Message } from "../../models/message.model";
import { UserToken } from "../../models/user.model";
import { AppServiceToken } from "../../models/app.service.model";
import { CompanyToken } from "../../models/company.model";
import { NotificationUnread } from "../../models/notification.model";
import { CompanySettings } from "../../models/company.settings.model";
import { Settings } from "../../models/settings.model";
import { CompanyAccountingAccounts } from "../../models/company.accounting.accounts.model";
import { AccountingAccount } from "../../models/accounting.account.model";
import { CompanyAccountingEntries } from "../../models/company.accounting.entries.model";
import { AccountingEntry } from "../../models/accounting.entry.model";
import { StorageCenter } from "../../models/storage.center.model";
import { Variant } from "../../models/variant.model";
import { CompanyProductVariants } from "../../models/company.product.variants.model";
import { Contact } from "../../models/contact.model";
import { CompanyTreasuryAccounts } from "../../models/company.treasury.accounts.model";
import { CompanyStorageCenters } from "../../models/company.storage.centers.model";
import { TreasuryAccount } from "../../models/treasury.account.model";
import { CompanyServices } from "../../models/company.services.model";
import { Service } from "../../models/service.model";
import { CompanyProducts } from "../../models/company.products.model";
import { Product } from "../../models/product.model";
import { StateLanguage } from "../../languages/config/StateLanguage";
import { GlobalSwal } from "../../styles/swal.style";
import { authCompanies, authCompany, authService, authUser, authApiKey } from "../../scripts/authentication.script";
import { setCookie } from "../../scripts/cookies.script";
import { getError, getMessage } from "../../languages/translations/response";
import { errorWebHandler } from "../../scripts/error.web.handler.script";
import { mainInterceptor } from "../../scripts/app.interceptor.axios";

import AppNavbar from "../../components/Navbar";
import AppHeader from "../../components/Header";
import AppTitle from "../../components/Title";
import AppFooter from "../../components/Footer";
import AppOverlay from "../../components/Overlay";
import AppDropdownUserProfile from "../../components/dropdown/DropdownUserProfile";
import AppDropdownNotifications from "../../components/dropdown/DropdownNotifications";
import AppDrawerDigitalAdminPro from "../../components/drawer/DrawerDigitalAdminPro";
import FloatingDrawer from "../../components/drawer/FloatingDrawer";
import PdfViewerPushPanel from "../../components/panel/PdfViewerPushPanel";
import { FloatingDrawerProvider, useFloatingDrawer } from "../../contexts/FloatingDrawerContext";
import { ChatProviderGated } from "../../contexts/ChatContext";
import { PdfViewerProvider, usePdfViewer } from "../../contexts/PdfViewerContext";
import { SubscriptionProvider, useSubscription } from "../../contexts/SubscriptionContext";
import { CatalogProvider, useCatalog } from "../../contexts/CatalogContext";
import { UpgradeModalProvider } from "../../contexts/UpgradeModalContext";
import SubscriptionBanner from "../../components/banner/SubscriptionBanner";
import ModalUpgradePlan from "../../components/modal/ModalUpgradePlan";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { navBarShow } from "../../utils/nav.bar.util";

type ContexType = {
  asideMinimize: string;
  setAsideMinimize: Dispatch<SetStateAction<string>>;
  setRoute: Dispatch<SetStateAction<{ path: { root: string; branch: string } | null; company: boolean } | null>>;
  userLoggedIn: UserToken | null;
  appServiceForUser: AppServiceToken | null;
  companyForUser: CompanyToken | null;
  setUserLoggedIn: Dispatch<SetStateAction<UserToken | null>>;
  loadNotificationsUnread: Function;

  settingsForCompany: Settings | null;
  accountingAccountsForCompany: AccountingAccount[] | null;
  accountingCreditEntriesForCompany: AccountingEntry[] | null;
  accountingDebitEntriesForCompany: AccountingEntry[] | null;
  treasuryAccountsForCompany: TreasuryAccount[] | null;
  contactsForCompany: Contact[] | null;
  servicesForCompany: Service[] | null;
  productsForCompany: Product[] | null;
  productVariantsForCompany: Variant[] | null;
  storageCentersForCompany: StorageCenter[] | null;
  reloadSession: Function;
  loadCompanyForUser: Function;
  loadSettingsForCompany: Function;
  loadAccountingAccountsForCompany: Function;
  loadAccountingCreditEntriesForCompany: Function;
  loadAccountingDebitEntriesForCompany: Function;
  loadTreasuryAccountsForCompany: Function;
  loadContactsForCompany: Function;
  loadServicesForCompany: Function;
  loadProductsForCompany: Function;
  loadProductproductVariantsForCompany: Function;
  loadStorageCentersForCompany: Function;
};

export interface MainPageProps {}

let errorResponse: Error,
  messageResponse: Message,
  notificationsUnreadResponse: NotificationUnread,
  settingsResponse: CompanySettings,
  accounitngAccuntsResponse: CompanyAccountingAccounts,
  accountingCreditEntriesResponse: CompanyAccountingEntries,
  accountingDebitEntriesResponse: CompanyAccountingEntries,
  treasuryAccountsResponse: CompanyTreasuryAccounts,
  servicesResponse: CompanyServices,
  productsResponse: CompanyProducts,
  productVariantsResponse: CompanyProductVariants,
  storageCentersResponse: CompanyStorageCenters;

const MainPage: React.FunctionComponent<MainPageProps> = (props) => {
  const { lang } = StateLanguage();
  const didRun = useRef(false);
  const fullCompanyLoadedId = useRef<string | null>(null);
  const taxCodesRef = useRef<any[] | null>(null);

  const [mounted, setMounted] = useState(false);
  const [asideMinimize, setAsideMinimize] = useState("off");
  const [activeDrawer, setActiveDrawer] = useState({ value: "off", aside: "off", button: "off" });
  const [scrollVisibility, setScrollVisibility] = useState({ header: "off", top: "off" });
  const [route, setRoute] = useState<{ path: { root: string; branch: string } | null; company: boolean } | null>(null);
  const [userLoggedIn, setUserLoggedIn] = useState<UserToken | null>(null);
  const [appServiceForUser, setAppServiceForUser] = useState<AppServiceToken | null>(null);
  const [companyForUser, setCompanyForUser] = useState<CompanyToken | null>(null);
  const [companiesForUser, setCompaniesForUser] = useState<CompanyToken[] | null>(null);
  const [notificationsUnread, setNotificationsUnread] = useState<number>(0);

  const [appServicesForUser, setAppServicesForUser] = useState<AppServiceToken[] | null>(null);
  const [settingsForCompany, setSettingsForCompany] = useState<Settings | null>(null);
  const [accountingAccountsForCompany, setAccountingAccountsForCompany] = useState<AccountingAccount[] | null>([]);
  const [accountingCreditEntriesForCompany, setAccountingCreditEntriesForCompany] = useState<AccountingEntry[] | null>([]);
  const [accountingDebitEntriesForCompany, setAccountingDebitEntriesForCompany] = useState<AccountingEntry[] | null>([]);
  const [treasuryAccountsForCompany, setTreasuryAccountsForCompany] = useState<TreasuryAccount[] | null>([]);
  const [productVariantsForCompany, setProductVariantsForCompany] = useState<Variant[] | null>(null);
  const [storageCentersForCompany, setStorageCentersForCompany] = useState<StorageCenter[] | null>(null);
  const [contactsForCompany, setContactsForCompany] = useState<Contact[] | null>(null);
  const [servicesForCompany, setServicesForCompany] = useState<Service[] | null>(null);
  const [productsForCompany, setProductsForCompany] = useState<Product[] | null>(null);

  // Panel layout — push vs overlay decision
  // Chat is always overlay. Only copilot and PDF push the content.
  const { isPushMode: floatingPushRaw, isOpen: floatingOpen, activeMode: floatingActiveMode } = useFloatingDrawer();
  const { isPushModePdf: pdfPushRaw, isOpen: pdfOpen } = usePdfViewer();
  const isVeryWide = useMediaQuery('(min-width: 1600px)');

  // Copilot is open in push mode only when it is the active floating panel
  const copilotOpen = floatingOpen && floatingActiveMode === 'copilot';
  const copilotPushRaw = floatingPushRaw && copilotOpen;

  // When both panels are open, push mode requires >= 1600px (3 zones)
  // When only one panel is open, use each context's own push threshold (1200px for PDF, 1400px for Copilot)
  const bothOpen = pdfOpen && copilotOpen;
  const effectivePdfPush = bothOpen ? (pdfPushRaw && isVeryWide) : pdfPushRaw;
  const effectiveCopilotPush = bothOpen ? (copilotPushRaw && isVeryWide) : copilotPushRaw;
  const anyPushPanel = effectivePdfPush || effectiveCopilotPush;

  const prevAsideStateRef = useRef<string | null>(null);

  useEffect(() => {
    if (anyPushPanel) {
      // Save current aside state and minimize
      if (prevAsideStateRef.current === null) {
        prevAsideStateRef.current = asideMinimize;
      }
      if (asideMinimize !== 'on') {
        setAsideMinimize('on');
        navBarShow('button-navbar-aside-minimize');
      }
    } else {
      // Restore aside state when leaving push mode
      if (prevAsideStateRef.current !== null) {
        const restore = prevAsideStateRef.current;
        prevAsideStateRef.current = null;
        if (restore !== asideMinimize) {
          setAsideMinimize(restore);
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anyPushPanel]);

  const { refreshSubscription } = useSubscription();

  const loadSession = async () => {
    setUserLoggedIn(authUser());
    setAppServiceForUser(authService());
    const company = authCompany();
    setCompanyForUser(company);

    // Refetch companies from API to avoid stale cookie
    const apiKey = authApiKey();
    let companiesFetched = false;
    if (apiKey) {
      try {
        const res = await ApiDigitalAuthUser.getMeCompanies(apiKey);
        if (res.status === 200 && res.data) {
          const payload: any = res.data;
          const rawList = Array.isArray(payload) ? payload : (payload?.companies ?? []);
          // Trim to CompanyToken shape to stay under cookie 4KB limit
          const list = rawList.map((c: any) => ({
            id: c.id ?? c._id ?? '',
            uuid: c.uuid ?? '',
            name: c.name ?? '',
            logo: (c.logo && typeof c.logo === 'string' && c.logo.startsWith('data:')) ? '' : (c.logo ?? null),
            is_current: c.is_current ?? false,
            address: c.address ?? {},
            roles: c.roles ?? [],
          }));
          setCookie("companies", list);
          setCompaniesForUser(list);
          companiesFetched = true;

          // If no current company in cookie, pick the one marked is_current
          if (!company && list.length > 0) {
            const current = list.find((c: any) => c.is_current === true) || list[0];
            setCookie("company", current);
            setCompanyForUser(current);
          }
        }
      } catch (e) {
        // refetch failed — fall back to cookie
      }
    }
    if (!companiesFetched) {
      setCompaniesForUser(authCompanies());
    }

    if ((company || authCompany()) && (company?.id || authCompany()?.id)) {
      loadNotificationsUnread();
    }

    refreshSubscription();
  };

  const loadNotificationsUnread = async () => {
    await ApiDigitalAdminNotification.getNotificationsUnread()
      .then((response) => {
        if (response.status === 200) {
          notificationsUnreadResponse = response.data;
          setNotificationsUnread(notificationsUnreadResponse.count);
        } else {
          errorResponse = response.data;

          GlobalSwal.fire({
            title: getError(errorResponse.code, lang.code, errorResponse.message),
            text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
            icon: "error",
            confirmButtonText: lang.labels.okGotIt,
          });
        }
      })
      .catch((error) => {
        errorWebHandler(lang, error);
      });
  };

  const reloadSession = async (
    authorization: string | null,
    app_service_api_key: string | null,
    company_id: string | null,
    callback: any,
  ) => {
    if (authorization && authorization.length > 0) {
      setCookie("access", authorization);
    }
    setUserLoggedIn(authUser());
    setAppServiceForUser(authService());
    setCompanyForUser(authCompany());

    // Refetch companies from API to avoid stale cookie
    const apiKey = app_service_api_key || authApiKey();
    if (apiKey) {
      try {
        const res = await ApiDigitalAuthUser.getMeCompanies(apiKey);
        if (res.status === 200 && res.data) {
          const payload: any = res.data;
          const rawList = Array.isArray(payload) ? payload : (payload?.companies ?? []);
          // Trim to CompanyToken shape to stay under cookie 4KB limit
          const list = rawList.map((c: any) => ({
            id: c.id ?? c._id ?? '',
            uuid: c.uuid ?? '',
            name: c.name ?? '',
            logo: (c.logo && typeof c.logo === 'string' && c.logo.startsWith('data:')) ? '' : (c.logo ?? null),
            is_current: c.is_current ?? false,
            address: c.address ?? {},
            roles: c.roles ?? [],
          }));
          setCookie("companies", list);
          setCompaniesForUser(list);
        } else {
          setCompaniesForUser(authCompanies());
        }
      } catch {
        setCompaniesForUser(authCompanies());
      }
    } else {
      setCompaniesForUser(authCompanies());
    }

    refreshSubscription();
    callback();
  };

  const loadCompanyForUser = async (api_key: string, id_company: string, callback: any) => {
    await ApiDigitalAuthCompany.getCompany(api_key, id_company)
      .then((response) => {
        if (response.status === 200 && response.data) {
          setCompanyForUser(response.data);
          callback(response.data);
        } else {
          setCompanyForUser(authCompany());
          callback(authCompany());
        }
      })
      .catch((e) => {
        setCompanyForUser(authCompany());
        callback(authCompany());
      });
  };

  const loadSettingsForCompany = async () => {
    try {
      const [settingsRes, vatRes] = await Promise.all([
        SettingsDA.getSettings(),
        companyForUser ? AccountingAccountDA.getVatRegime(companyForUser.id) : Promise.resolve(null),
      ]);

      if (settingsRes.status === 200) {
        const rawData = settingsRes.data;
        const settings = rawData?.data ?? rawData;

        const vatOverrides = (vatRes && vatRes.status === 200 && vatRes.data)
          ? {
              subject_tax: vatRes.data.subject_tax,
              tax_method: vatRes.data.tax_method,
              tax_rate: vatRes.data.tax_rate,
              tax_declaration: vatRes.data.tax_declaration,
            }
          : {};

        setSettingsForCompany({
          ...settings,
          ...vatOverrides,
          tax_fees: taxCodesRef.current ?? settings.tax_fees ?? [],
        });
      } else {
        errorResponse = settingsRes.data;

        GlobalSwal.fire({
          title: getError(errorResponse?.code, lang.code, errorResponse?.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: "error",
          confirmButtonText: lang.labels.okGotIt,
        });
      }
    } catch (error) {
      errorWebHandler(lang, error);
    }
  };

  const loadTaxCodes = async (id_company: string) => {
    await AccountingAccountDA.getTaxCodes(id_company)
      .then((response) => {
        if (response.status === 200) {
          const taxCodes = Array.isArray(response.data) ? response.data : [];
          taxCodesRef.current = taxCodes;
          setSettingsForCompany((prev) => {
            if (prev) return { ...prev, tax_fees: taxCodes };
            return prev;
          });
        }
      })
      .catch(() => {
        // Tax codes load failed — tax dropdowns will remain empty
      });
  };

  const loadAccountingAccountsForCompany = async (id_company: string) => {
    await AccountingAccountDA.getAccountingAccounts(id_company, [], [], [])
      .then((response) => {
        if (response.status === 200) {
          const rawData = response.data;
          setAccountingAccountsForCompany(rawData?.accounting_accounts ?? (Array.isArray(rawData) ? rawData : []));
        }
      })
      .catch((error) => {
        errorWebHandler(lang, error);
      });
  };

  const loadAccountingCreditEntriesForCompany = async (id_company: string, id_contact?: string) => {
    await AccountingEntryDA.getAccountingCreditIncompleteEntries(id_company, id_contact)
      .then((response) => {
        if (response.status === 200 || response.status === 304) {
          const rawData = response.data;
          setAccountingCreditEntriesForCompany(rawData?.accounting_entries ?? []);
        }
      })
      .catch((error) => {
        errorWebHandler(lang, error);
      });
  };

  const loadAccountingDebitEntriesForCompany = async (_id_company: string) => {
    setAccountingDebitEntriesForCompany([]);
  };

  const loadTreasuryAccountsForCompany = async (id_company: string) => {
    await TreasuryAccountDA.getTreasuryAccounts(id_company)
      .then((response) => {
        if (response.status === 200) {
          const rawData = response.data;
          setTreasuryAccountsForCompany(rawData?.treasury_accounts ?? []);
        }
      })
      .catch((error) => {
        errorWebHandler(lang, error);
      });
  };

  const loadContactsForCompany = async (_id_company: string) => {
    try {
      const response = await ApiDigitalAdminContact.getContacts(_id_company, '', '', '', '', 1, 1000)

      if (response.status === 200 || response.status === 304) {
        const payload = response.data ?? {}

        if (Array.isArray(payload.items)) {
          setContactsForCompany(normalizeContacts(payload.items))
        } else if (Array.isArray(payload)) {
          setContactsForCompany(normalizeContacts(payload))
        } else if (Array.isArray(payload.contacts)) {
          setContactsForCompany(normalizeContacts(payload.contacts))
        } else {
          console.warn('[Main] loadContactsForCompany: unrecognized response shape', payload)
          setContactsForCompany([])
        }
      } else {
        setContactsForCompany([])
      }
    } catch (err) {
      console.error('[Main] loadContactsForCompany failed', err)
      setContactsForCompany([])
    }
  };

  const loadServicesForCompany = async (_id_company: string) => {
    try {
      const response = await ServiceDA.getServices(_id_company, '', '', '', '')
      if (response.status === 200 || response.status === 304) {
        const payload = response.data ?? {}
        if (Array.isArray(payload.items)) {
          setServicesForCompany(payload.items)
        } else if (Array.isArray(payload)) {
          setServicesForCompany(payload)
        } else if (Array.isArray(payload.services)) {
          setServicesForCompany(payload.services)
        } else {
          setServicesForCompany([])
        }
      } else {
        setServicesForCompany([])
      }
    } catch {
      setServicesForCompany([])
    }
  };

  const loadProductsForCompany = async (_id_company: string) => {
    try {
      const response = await ProductDA.getProducts(_id_company, '', '', '', '')
      if (response.status === 200 || response.status === 304) {
        const payload = response.data ?? {}
        if (Array.isArray(payload.items)) {
          setProductsForCompany(payload.items)
        } else if (Array.isArray(payload)) {
          setProductsForCompany(payload)
        } else if (Array.isArray(payload.products)) {
          setProductsForCompany(payload.products)
        } else {
          setProductsForCompany([])
        }
      } else {
        setProductsForCompany([])
      }
    } catch {
      setProductsForCompany([])
    }
  };

  const loadProductproductVariantsForCompany = async (_id_company: string) => {
    // TODO: decomment when product-service is connected
  };

  const loadStorageCentersForCompany = async (_id_company: string) => {
    try {
      const response = await StorageCenterDA.getStorageCenters(_id_company, '', '', '')
      if (response.status === 200 || response.status === 304) {
        const payload = response.data ?? {}
        if (Array.isArray(payload.items)) {
          setStorageCentersForCompany(payload.items)
        } else if (Array.isArray(payload)) {
          setStorageCentersForCompany(payload)
        } else if (Array.isArray(payload.storage_centers)) {
          setStorageCentersForCompany(payload.storage_centers)
        } else {
          setStorageCentersForCompany([])
        }
      } else {
        setStorageCentersForCompany([])
      }
    } catch {
      setStorageCentersForCompany([])
    }
  };

  useEffect(() => {
    if (userLoggedIn && appServiceForUser) {
      if (userLoggedIn.new_user) {
        toast.info(
          <div style={{ marginTop: "10px", marginBottom: "10px" }}>
            <strong style={{ display: "block", marginBottom: "5px" }}>{lang.labels.newRegisteredUser}</strong>
            <div>{lang.labels.pleaseCheckEmailToValidateAccount}</div>
          </div>,
          {
            toastId: "info",
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "light",
            closeButton: false,
            style: {
              backgroundColor: "#D9F5FB",
              color: "#000000",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.5)",
              marginTop: "10px",
            },
          },
        );
      } else {
        if (!toast.isActive("success")) {
          toast.success(lang.labels.yourSessionIsActiveCongratulations, { toastId: "success" });
        } else {
          toast.update("success", { render: lang.labels.yourSessionIsActiveCongratulations });
        }

        if (!userLoggedIn.verified) {
          // Re-check verified status from API — the cookie may be stale
          (async () => {
            let stillUnverified = true
            try {
              const userRes = await ApiDigitalAuthUser.getUser(appServiceForUser.api_key)
              if (userRes.status === 200 && userRes.data?.verified === true) {
                stillUnverified = false
                const userToken: UserToken = {
                  id: userRes.data.id ?? userLoggedIn.id,
                  uuid: userRes.data.uuid ?? userLoggedIn.uuid,
                  avatar: userRes.data.avatar ?? userLoggedIn.avatar,
                  first_name: userRes.data.first_name ?? userLoggedIn.first_name,
                  last_name: userRes.data.last_name ?? userLoggedIn.last_name,
                  email: userRes.data.email ?? userLoggedIn.email,
                  verified: true,
                  new_user: userRes.data.new_user ?? userLoggedIn.new_user,
                  locale: userRes.data.locale ?? userLoggedIn.locale
                }
                setUserLoggedIn(userToken)
                setCookie('user', userToken)
              }
            } catch {
              // API error — fall through, show popup as before
            }

            if (stillUnverified) {
              GlobalSwal.fire({
                title: lang.labels.accountNotValidated,
                text: lang.labels.anEmailSentToValidateAccount,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: lang.labels.resend,
                cancelButtonText: lang.labels.okGotIt,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await ApiDigitalAuthAuthentication.resendVerification(appServiceForUser.api_key)
                    .then((response) => {
                      if (response.status === 200) {
                        messageResponse = response.data;

                        GlobalSwal.fire({
                          title: getMessage(messageResponse.message, lang.code),
                          text: lang.labels.pleaseCheckYourEmailInbox,
                          icon: "success",
                          showConfirmButton: false,
                          timer: 2200,
                        });
                      } else {
                        errorResponse = response.data;

                        GlobalSwal.fire({
                          title: getError(errorResponse.code, lang.code, errorResponse.message),
                          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                          icon: "error",
                          confirmButtonText: lang.labels.okGotIt,
                        });
                      }
                    })
                    .catch((error) => {
                      errorWebHandler(lang, error);
                    });
                }
              });
            }
          })()
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoggedIn, lang.code]);

  useEffect(() => {
    if (companyForUser && companyForUser.id) {
      loadSettingsForCompany();
      loadTreasuryAccountsForCompany(companyForUser.id);
      loadTaxCodes(companyForUser.id);
      loadAccountingAccountsForCompany(companyForUser.id);
      loadContactsForCompany(companyForUser.id);

      if (fullCompanyLoadedId.current !== companyForUser.id) {
        fullCompanyLoadedId.current = companyForUser.id;
        const api_key = authApiKey();
        ApiDigitalAuthCompany.getCompany(api_key, companyForUser.id)
          .then((response) => {
            if (response.status === 200 && response.data) {
              setCompanyForUser(response.data);
            }
          })
          .catch(() => {});
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyForUser]);

  useEffect(() => {
    setMounted(true);

    const { requestId, retryId, refreshId } = mainInterceptor();

    if (!didRun.current) {
      didRun.current = true;
      loadSession();
    }

    function cleanupModals() {
      document.querySelectorAll("body.modal-open").forEach((node) => {
        node.removeAttribute("class");
        node.removeAttribute("style");
      });
      document.querySelectorAll(".modal-backdrop.show").forEach((node) => {
        node.remove();
      });
      document.querySelectorAll(".modal.fade.show").forEach((node) => {
        node.classList.remove("show");
      });
    }

    cleanupModals();

    window.addEventListener("popstate", cleanupModals);

    return () => {
      axios.interceptors.request.eject(requestId);
      axios.interceptors.response.eject(retryId);
      axios.interceptors.response.eject(refreshId);

      window.removeEventListener("popstate", cleanupModals);

      cleanupModals();

      setMounted(false);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!mounted) return null;

  return (
    <div className="header-fixed header-tablet-and-mobile-fixed aside-fixed aside-secondary-enabled h-100" data-kt-aside-minimize={asideMinimize} data-kt-drawer={activeDrawer.value} data-kt-sticky-header={scrollVisibility.header} data-kt-scrolltop={scrollVisibility.top}>
      <div className="d-flex flex-column flex-root h-100">
        <div className="page d-flex flex-row flex-column-fluid">
          <AppNavbar asideMinimize={asideMinimize} activeDrawer={activeDrawer} scrollVisibility={scrollVisibility} setAsideMinimize={setAsideMinimize} setActiveDrawer={setActiveDrawer} setScrollVisibility={setScrollVisibility} notificationsUnread={notificationsUnread} loadSession={loadSession} companiesForUser={companiesForUser}></AppNavbar>
          <div className={`wrapper d-flex ${anyPushPanel ? 'flex-row' : 'flex-column'} flex-row-fluid`} style={{transition: 'all 0.3s ease'}}>
            <div className="d-flex flex-column flex-grow-1" style={{minWidth: 0, transition: 'all 0.3s ease'}}>
              <SubscriptionBanner />
              <AppHeader
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                route={route}
                appServiceForUser={appServiceForUser}
                companyForUser={companyForUser}
                treasuryAccountsForCompany={treasuryAccountsForCompany}
              ></AppHeader>
              <div className="content d-flex flex-column flex-column-fluid">
                <div className="container-xxl h-100 pb-5" key={companyForUser?.id ?? 'none'}>
                  <AppTitle route={route} companyForUser={companyForUser}></AppTitle>
                  <Outlet
                    context={{
                      asideMinimize,
                      setAsideMinimize,
                      setRoute,
                      userLoggedIn,
                      setUserLoggedIn,
                      appServiceForUser,
                      companyForUser,
                      settingsForCompany,
                      accountingAccountsForCompany,
                      accountingCreditEntriesForCompany,
                      accountingDebitEntriesForCompany,
                      treasuryAccountsForCompany,
                      contactsForCompany,
                      servicesForCompany,
                      productsForCompany,
                      productVariantsForCompany,
                      storageCentersForCompany,
                      reloadSession,
                      loadCompanyForUser,
                      loadNotificationsUnread,
                      loadSettingsForCompany,
                      loadAccountingAccountsForCompany,
                      loadAccountingCreditEntriesForCompany,
                      loadAccountingDebitEntriesForCompany,
                      loadTreasuryAccountsForCompany,
                      loadContactsForCompany,
                      loadServicesForCompany,
                      loadProductsForCompany,
                      loadProductproductVariantsForCompany,
                      loadStorageCentersForCompany,
                    }}
                  ></Outlet>
                </div>
              </div>
              <AppFooter></AppFooter>
            </div>
            <PdfViewerPushPanel isPush={effectivePdfPush} />
            <FloatingDrawer isPushMode={effectiveCopilotPush} />
          </div>
        </div>
      </div>
      {/* AppScroll (scroll-to-top button) removed — conflicts with FAB */}
      <AppOverlay activeDrawer={activeDrawer} setActiveDrawer={setActiveDrawer}></AppOverlay>
      <AppDrawerDigitalAdminPro activeDrawer={activeDrawer} setActiveDrawer={setActiveDrawer} route={route}></AppDrawerDigitalAdminPro>
      <AppDropdownUserProfile activeDrawer={activeDrawer} setActiveDrawer={setActiveDrawer} userLoggedIn={userLoggedIn} appServiceForUser={appServiceForUser} setUserLoggedIn={setUserLoggedIn}></AppDropdownUserProfile>
      <AppDropdownNotifications userLoggedIn={userLoggedIn} appServiceForUser={appServiceForUser} companyForUser={companyForUser} notificationsUnread={notificationsUnread} loadNotificationsUnread={loadNotificationsUnread} reloadSession={reloadSession}></AppDropdownNotifications>
    </div>
  );
};

export function UseOutletContext() {
  return useOutletContext<ContexType>();
}

const CatalogVocabularyBridge: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { vocabulary } = useCatalog();
  const { setVocabulary } = useSubscription();
  useEffect(() => { setVocabulary(vocabulary); }, [vocabulary, setVocabulary]);
  return <>{children}</>;
};

const MainPageWithCopilotLayout: React.FunctionComponent = () => (
  <SubscriptionProvider>
    <CatalogProvider>
      <CatalogVocabularyBridge>
        <UpgradeModalProvider>
          <FloatingDrawerProvider>
            <ChatProviderGated>
              <PdfViewerProvider>
                <MainPage />
                <ModalUpgradePlan />
              </PdfViewerProvider>
            </ChatProviderGated>
          </FloatingDrawerProvider>
        </UpgradeModalProvider>
      </CatalogVocabularyBridge>
    </CatalogProvider>
  </SubscriptionProvider>
);

export default MainPageWithCopilotLayout;
